<template>
    <!-- <button class="button is-success is-fullwidth" ></button> -->
      <button class="button is-primary" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-search"></i>
    </span>
    <span v-if="label">{{label}}</span>
  </button>
</template>

<script>
export default {
  name: 'SearchButton',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/SearchButton.vue